const featuresPay = {
    featureTitle: '基于数据做出商业决策',
    featureDescription:
        '了解哪些商品畅销并带来最高利润，随时随地访问财务报告。让您的生意尽在掌握！',
    featureButton: "高级订阅",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: '起价',
    featureEndingText: '千元',

    features: [
        {
            title: '无限商品',
            description: '添加您拥有的所有商品，没有任何限制。'
        },
        {
            title: '无限员工',
            description: '将员工/管理员无限制地添加到企业中。'
        },
        {
            title: '无限历史记录',
            description: '无限制查看旧库存记录的变更。'
        },
        {
            title: '历史筛选',
            description: '按类型、类别、员工和日期轻松查看历史记录。'
        },
        {
            title: '导出到Excel',
            description: '一键将库存记录历史导出到Microsoft Excel。'
        },
        {
            title: '导出到PDF',
            description: '一键将最新的商品和库存列表导出为PDF。'
        }
    ],
    warehousesGuide: [
        {
            desc: '创建多个仓库以更好地管理库存。'
        },
        {
            desc: '将产品分配到特定位置。'
        },
        {
            desc: '监控各仓库的库存水平。'
        }
    ],
    addVariantsGuide: [
        { desc: '添加尺寸、颜色或材质的变体。' },
        { desc: '为每个变体设置库存水平。' },
        { desc: '跨仓库跟踪库存。' }
    ]
}

export default featuresPay;
